"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LENDING_VAULT_WATCHER = void 0;
const types_1 = require("../types");
exports.LENDING_VAULT_WATCHER = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: '0xd129cc3a352289ec73ab4a64d630121aad5b9e31',
    [types_1.Networks.Arbitrum]: '0x0C6BE493CEFbFc135249156762d9977803B67B42',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '0x5833C2BCe6C29323401e9eD171f1599001f5B288',
    [types_1.Networks.Base]: '0x1c79103cEc595b8af673Cd41271861FFA3B2BEDA',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '0x0774eBA9e1b20B0f191AbC59a5798838F4bd938c',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '0x0680AD510475844a0555914FD38979B31FdA3b2f',
    [types_1.Networks.Linea]: '0x0680AD510475844a0555914FD38979B31FdA3b2f',
};
